<template>
    <div>
        <h1 style="font-size: 24px; color: black;">版本更新文案配置</h1>
        <el-card   shadow="never">
            <el-row  type="flex"  align="middle" >
                <el-col :span="5">
                        <span > 系统：</span>
                        <el-select  v-model="queryData.sys" :clearable="true" >
                        <el-option
                                v-for="(value,key) in sysTypes"
                                :label="value"
                                :value="Number(key)"
                                :key="Number(key)">
                        </el-option>
                        </el-select>
                </el-col>
                <el-col :span="5">
                        <span > 应用：</span>
                        <el-select  v-model="queryData.appType" :clearable="true">
                        <el-option
                                v-for="item in iosAppList"
                                :label="item.appName"
                                :value="item.appId"
                                :key="item.appId">
                        </el-option>
                        </el-select>
                </el-col>
                <el-col :span="8">
                        <span > 日期：</span>
                        <el-date-picker
                                v-model="queryData.timeDate"
                                type="daterange"
                                :clearable="false"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                >
                        </el-date-picker>
                </el-col>

                <el-form-item label="系统:" >
                    
                </el-form-item>
                <el-form-item label="应用:" >
                    
                </el-form-item>
            </el-row>
            <el-row  type="flex"  align="middle" >
                <el-col :span="5">
                    <el-button  type="primary" @click="queryList">查询</el-button>
                    <el-button  type="primary" @click="showDetails('创建')">创建</el-button>              
                </el-col>
            </el-row>
        </el-card>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" >
            <el-form :model="form.formData"   label-width="150px">
                <el-form-item label="系统:" >
                    <el-select  v-model="form.formData.sys" >
                        <el-option
                                v-for="(value,key) in sysTypes"
                                :label="value"
                                :value="Number(key)"
                                :key="Number(key)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="应用:" >
                    <el-select  v-model="form.formData.appType">
                        <el-option
                                v-for="item in iosAppList"
                                :label="item.appName"
                                :value="item.appId"
                                :key="item.appId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="更新类型:" >
                    <el-select  v-model="form.formData.updateType">
                        <el-option
                                v-for="(value,key) in iosUpdateTypes"
                                :label="value"
                                :value="Number(key)"
                                :key="Number(key)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题:" prop="title" >
                    <el-input  style="width: 300px" type="text" v-model="form.formData.title" ></el-input>
                </el-form-item>
                <el-form-item label="副标题:" prop="subTitle" >
                    <el-input  style="width: 300px" type="text" v-model="form.formData.subTitle" ></el-input>
                </el-form-item>
                <el-form-item label="描述:" prop="description" >
                    <el-input  style="width: 300px" type="textarea" :rows="10" v-model="form.formData.description"   ></el-input>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirm">确 定</el-button>
                    <el-button type="info" @click="cancel">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <h1>
            <el-table border :data="dataList"  >

                <el-table-column  label="id"  prop="id" ></el-table-column>

                <el-table-column  label="操作系统"  prop="sys" >
                    <template slot-scope="scope">
                        {{ scope.row.sys | commonFilter(sysTypes)}}
                    </template>
                </el-table-column>
                <el-table-column  label="应用"  prop="appType" >
                    <template slot-scope="scope">
                        {{ scope.row.appType | commonFilter(iosAppObj)}}
                    </template>
                </el-table-column>
                <el-table-column  label="更新类型"  prop="updateType" >
                    <template slot-scope="scope">
                        {{ scope.row.updateType | commonFilter(iosUpdateTypes) }}
                    </template>
                </el-table-column>
                <el-table-column  label="标题"  prop="title" show-overflow-tooltip >
                    <template slot-scope="scope">
                        {{ scope.row.title }}
                    </template>
                </el-table-column>
                <el-table-column  label="副标题"  prop="subTitle" show-overflow-tooltip >
                    <template slot-scope="scope">
                        {{ scope.row.subTitle }}
                    </template>
                </el-table-column>
                <el-table-column  label="描述文案"  prop="description" show-overflow-tooltip >
                    <template slot-scope="scope">
                        {{ scope.row.description }}
                    </template>
                </el-table-column>
                 <el-table-column  label="创建时间"  prop="createDt" width="160px">
                     <template slot-scope="scope">
                         {{ scope.row.createDt | dateTimeFormat}}
                     </template>
                 </el-table-column>
                 <el-table-column  label="更新时间"  prop="updateDt" width="160px">
                     <template slot-scope="scope">
                         {{ scope.row.updateDt | dateTimeFormat}}
                     </template>
                 </el-table-column> 
                <el-table-column  label="操作" align="center" width="150px">
                    <template slot-scope="scope">
                    <el-button  plain size="mini" type="primary" @click="showDetails('编辑',scope.row)">编辑</el-button>
                    <el-button  plain size="mini" type="danger"   @click="removeConfig(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page.page"
                        :page-sizes="[1,10,20,30,50]"
                        :page-size="page.size"
                        layout="total, sizes, prev, pager, next"
                        :total="page.totalElements">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
    import {
       deleteVersionMessage,
       updateVersionMessage,
       searchVersionMessage
    } from "@/http/womensApi";
    import {sysTypes,iosUpdateTypes} from '@/constants/common/basic-data'
    import settingMix from '@/utils/mix/common-setting'
    // import DateUtil from '@/utils/DateUtil'
    import objUtil from '@/utils/ObjUtil'
    import store from '@/store'
    export default {
        name: "WomensVersionMessage",
        mixins: [settingMix],
        data(){
           return{
                versionCode:store.state.newProjectVersion.selectedVersion,
                appType:''+store.state.newProjectVersion.selectedAppType,
                needIosApp:true,
                iosAppObj:{},
                iosAppList: [],
                sysTypes:sysTypes,
                iosUpdateTypes:iosUpdateTypes,
               page: {
                   size: 20,
                   page: 1,
                   totalElements: null
               },
               dialogVisible: false,
               dialogTitle :'',
               queryData: {
                   sys:"",
                   appType:"",
                   timeDate: ['', ''],
               },
               dataList:[],
               form: {
                   createData:{
                       "id" : null,
                       "sys" :'',
                       "appType" :'',
                       "updateType" :'',
                       "title" :'',
                       "subTitle" :'',
                       "description" :'',
                       "createDt" :'',
                       "updateDt" :''
                   },
                   formData: {},
               },
               
               
           }
        },
        methods :{
            handleSizeChange(size) {
                this.page.size = size;
                this.queryList();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryList() ;
            },
            showDetails(title, row) {
                console.log(row);
                this.form.formData = objUtil.clone(this.form.createData)
                this.dialogTitle = title;
                this.dialogVisible = true;
                if(row){
                    this.form.formData = objUtil.clone(row)
                }
            },
            confirm(){
                let _message = '';
                if(this.form.formData.sys===''){
                    _message = '请输入操作系统'
                }else if (this.form.formData.appType===''){
                    _message = '请选择应用'
                }
                if(_message) {
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                updateVersionMessage(this.form.formData).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible = false;
                        this.queryList();
                    }
                })
            },
            cancel(){
                this.dialogVisible=false;
            },
            removeConfig(id){
                this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteVersionMessage(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.queryList();
                        }
                    });
                }).catch(() => {
                })
            },
            queryList(){
                let queryTrueData = {sys: this.queryData.sys, appType: this.queryData.appType}
                // console.log(this.queryData.timeDate)
                queryTrueData.startDt = this.queryData.timeDate[0]==='' ? null:this.queryData.timeDate[0];
                queryTrueData.endDt = this.queryData.timeDate[1]==='' ? null:this.queryData.timeDate[1];
                queryTrueData = Object.assign(queryTrueData, this.page)
                // console.log(queryTrueData)
                searchVersionMessage(queryTrueData).then(resp=> {
                    if (resp.data.status===0){
                       this.dataList=resp.data.info.content;
                       this.page.totalElements = resp.data.info.total;
                    }
                })
            },
            // initDateRange(){
            //     this.queryData.timeDate = DateUtil.getIntervalDate(7)
            // }
        },
        created() {
            // this.initDateRange()
            this.queryList();
            
        },
    }
</script>

<style scoped>

</style>
